import {
    Box,
    Button,
    CssBaseline,
    Paper,
    Stack,
    Typography,
    useTheme
} from '@mui/material';
import { Table, Container, Row, Col } from 'react-bootstrap';

import React, { useContext, useRef, useState } from 'react';
import Pagination from '../../general/Pagination';
import ExportContent from '../../ExportContent';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';


import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import AppModal from '../../AppModal';
import {PASS_KEY,WEB_KEY,BaseUrl} from '../../../api/AxiosApi'
import ExportContentEnergy from '../../ExportContentEnergy';
import { AuthenticationContext } from '../../../context/AuthenticationContext';
import ExportExcel from '../../exportExcel/ExportExcel1';
import ExportPdf from '../../exportPdf/ExportPdf';
let Radiation;
export default function EnergyReportingLogTable({ radiationName, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const tableRef = useRef(null);

    const LOGIN_ID = localStorage.getItem('LoginID')

    const LOC_CODE = LoggedInUserInfo?.Loc_Code
    

    // console.log('Table', TableData)
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(15);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(TableData.length / recordsPerPage)

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    if (TableData?.length > 0) {
        Radiation = TableData[0]
    }

    const logo = require('../../../assets/img/logos/logo 2.png');



const genPDF = async () => {
    await ExportPdf(
        ImageUrl,
        TableData,
        ValueOf1,
        ValueOf2,
        "Daily Energy Log",
        LoggedInUserInfo,
        logo,
        TableHead

    );
};


const exportToExcel = async () => {
    await ExportExcel(
        ImageUrl,
        TableData,
        ValueOf1,
        ValueOf2,
        "Daily Energy Log",
        LoggedInUserInfo
    );
};

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // console.log("tableRef.current", tableRef)

    return (
        <>
            <CssBaseline />
            <Box component={Stack} rowGap={spacing(1)} sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <ExportContentEnergy
                    excelTableRef={exportToExcel}
                    onGenPdf={genPDF}
                    ExcelExportFileName={`Daily Energy Log To ${ValueOf2} ${radiationName}`}
                    title={radiationName}
                    onFullScreen={handleOpen}
                    filterContent={
                        <Box flex={1} columnGap={spacing(1)} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <input type='date' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
                            <Typography variant='body1' >To</Typography>
                            <input type='date' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
                            <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
                        </Box>

                    }
                />

                {
                    currentRecords?.length > 0 ? <>


                        {/* TableContainer for making the table responsive */}

                        <div>
                            <Table ref={tableRef} id='table-to-pdf' striped bordered hover responsive>
                                <thead style={{}}>
                                    <tr style={{ textAlign: 'center' }}>
                                        {
                                            TableHead?.map((item, index) => {
                                                return (
                                                    <th style={{ padding: 15, whiteSpace: 'nowrap', backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentRecords?.map((item, index) => {
                                            // console.log('data', item)
                                            return (
                                                <tr key={index}>
                                                    {TableHead.map(key =>
                                                        <td style={{ textAlign: 'center', padding: spacing(1), whiteSpace: 'nowrap' }} align='center'>{item[key]}</td>
                                                    )}
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>


                        </div>

                        {/* Pagination */}
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Pagination nPages={nPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                        </Box>

                        {/* AppModal */}
                        <AppModal open={open} handleClose={handleClose}></AppModal>



                    </>

                        : <>
                            <Typography variant='body2' color={'black'} textAlign={'center'}>Data Loading...</Typography>
                        </>
                }

            </Box>
        </>
    )
}
